// Quotes rotated in the aside of the auth pages. The first three come from the design
// prototype, the rest from the register page and plan menu that this flow replaces.
// Marketing can append more; every entry needs quote, name, role and initials.
export const TESTIMONIALS = [
  {
    quote: 'POP is one of those ninja tools that only serious SEOs tend to use. I have used reports from POP to close some of the largest clients I have ever worked with. This will be my 5th year of renewal.',
    name: 'Everhardt Strauss',
    role: 'Director of Organic Search, Search Labs',
    initials: 'ES',
  },
  {
    quote: 'I would recommend POP because it is the only tool which gives you the assurance that you have closed any gaps to your competitors. It digs so deep into so many factors.',
    name: 'Henning Geiler',
    role: 'Pinpoint Media Design',
    initials: 'HG',
  },
  {
    quote: 'We run every client page through POP before it goes live. The Content Brief alone saves our writers hours per article.',
    name: 'Dana Whitfield',
    role: 'Head of Content, Northstar Agency',
    initials: 'DW',
  },
  {
    quote: 'Page Optimizer Pro is a game changer. We use it for developing great content for our client\'s websites. The ability to demonstrate to potential clients what changes are needed on their pages is a great sales tool.',
    name: 'Chuck Hersey',
    role: 'Partner, Team 218 Web Services',
    initials: 'CH',
  },
  {
    quote: 'After reworking our pages through POP for the proper structure and content, nearly every, if not all, of our page 2 and 3+ listings broke onto page 1.',
    name: 'Cris Carillo',
    role: 'SEM, Idea Tree Media',
    initials: 'CC',
  },
  {
    quote: 'What I like most about POP are the results. I\'ve had a number of pages shoot to position 1-3 within days of implementing the recommendations.',
    name: 'Mendy Perlman',
    role: 'SEO Specialist',
    initials: 'MP',
  },
]

export const ASIDE_CHIPS = ['7-day full refund', 'Unlimited domains', 'Cancel any time']
